import mixins from 'vue-typed-mixins';

import PlbscfTable from '@/components/plbscfTable/PlbscfTable.vue';

import CF計算書Mixin from '@/entries/user/mixins/CF計算書Mixin';
import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 計画三表Mixin from '@/entries/user/mixins/計画三表Mixin';

import { PlbscfTypeList } from '@/classes/service/AbstractPlbscfService';
import { PlbscfType } from '@/master/Plbscf';

export default mixins(RoutesMixin, 計画三表Mixin, CF計算書Mixin).extend({
  name: 'CF計算書',

  components: {
    PlbscfTable,
  },

  computed: {
    plbscfTypeLists(): PlbscfTypeList[] {
      return this.計画Plbscf.types.filter((typeList) =>
        [PlbscfType.CF計算書, PlbscfType.CF計算書_計算式].includes(typeList.type)
      );
    },
  },

  methods: {
    recalculate(): void {
      this.recalculateByTypeLists(this.plbscfTypeLists);
    },
  },
});
